export default __webpack_public_path__ + "40a0f837961cfa86cf1c080ff51d7c8c.png";